import MultiQuoteUseCase from "@domains/features/TOCJourney/useCases/MutiQuoteUseCase";
import PlaceNormalTradeUseCase from "@domains/features/TOCJourney/useCases/PlaceNormalTradeUseCase";
import PlaceTradeCommUseCase from "@domains/features/TOCJourney/useCases/PlaceTradeCommUseCase";
import OrderDetailsUseCase from "@domains/features/TOCJourney/useCases/orderDetailsUseCase";
import CheckMarginUseCase from "@domains/features/TOCJourney/useCases/CheckMarginUseCase";
import BrokerChargeUseCase from "@domains/features/TOCJourney/useCases/BrokerCharges";
import BrokerChargeCommUseCase from "@domains/features/TOCJourney/useCases/BrokerChargesComm";
import RmsSubLimitsUseCase from "@domains/features/TOCJourney/useCases/RmsSubLimitsUseCase";
import LimitsUseCase from "@domains/features/TOCJourney/useCases/LimitsUseCase";
import RmsHoldingUseCase from "@domains/features/TOCJourney/useCases/RMSHoldingsUseCase";
import TpinUseCase from "@domains/features/TOCJourney/useCases/TpinUseCase";
import AmoPlaceTradeUseCase from "@domains/features/TOCJourney/useCases/AmoPlaceTradeUseCase";
import AmoPlaceTradeCommUseCase from "@domains/features/TOCJourney/useCases/AmoPlaceTradeCommUseCase";
import BracketTradeUseCase from "@domains/features/TOCJourney/useCases/BracketTradeUseCase";
import AuthorizeUseCase from "@domains/features/TOCJourney/useCases/AuthorizeUseCase";
import AMOStatusUseCase from "@domains/features/TOCJourney/useCases/AMOStatusUseCase";
import EsipTradeUseCase from "@domains/features/TOCJourney/useCases/EsipTradeUseCase";
import CancelPlaceOrderUseCase from "@domains/features/TOCJourney/useCases/CancelPlaceOrder";
import CancelEsipOrderUseCase from "@domains/features/TOCJourney/useCases/CancelEsipOrder";
import ModifyOrderUseCase from "@domains/features/TOCJourney/useCases/ModifyOrder";
import MFPurchaseUseCase from "@domains/features/TOCJourney/useCases/MFPurchaseUseCase";
import NfoPurchaseUseCase from "@domains/features/TOCJourney/useCases/NfoPurchaseUseCase";
import MFSIPFrequencyUseCase from "@domains/features/TOCJourney/useCases/MFSipFrequencyUseCase";
import OFSTradeUseCase from "@domains/features/TOCJourney/useCases/PlaceOFSTradeUseCase";
import MFSIPStartDateUseCase from "@domains/features/TOCJourney/useCases/MFSipStartDateUseCase";
import MFSipMandateUseCase from "@domains/features/MandateFlow/useCases/MFMandateUseCase";
import MFBankDetailsUseCase from "@domains/features/MandateFlow/useCases/MFBankDetailsUseCase";
import MFCreateMandateUseCase from "@domains/features/MandateFlow/useCases/MFCreateMandateUseCase";
import MFMandateUploadUseCase from "@domains/features/MandateFlow/useCases/MFMandateUploadUseCase";
import PayBankDetailsUseCase from "@domains/features/PaymentFlow/useCases/IPayBankDetailsUseCase";
import PaymentGatewayUseCase from "@domains/features/PaymentFlow/useCases/IPaymentGatewayUseCase";
import MFPurchaseOrderUseCase from "@domains/features/TOCJourney/useCases/MFPurchaseOrderUseCase";
import MFParticularHoldingUseCase from "@domains/features/TOCJourney/useCases/MFParticularHolding";
import MFAllHoldingsUseCase from "@domains/features/TOCJourney/useCases/MFAllHoldingUseCase";
import DownloadMandateUseCase from "@domains/features/MandateFlow/useCases/DownloadMandateUseCase";
import EmandateUrlUseCase from "@domains/features/MandateFlow/useCases/EmandateUrlUseCase";
import MandateSwitchUseCase from "@domains/features/MandateFlow/useCases/MandateSwitchUseCase";
import TradePaymentUseCase from "@domains/features/PaymentFlow/useCases/TradePaymentUseCase";
import UPIListUseCase from "@domains/features/TOCJourney/useCases/UPIListUseCase";
import SpecificIPOUseCase from "@domains/features/TOCJourney/useCases/SpecificIPOUseCase";
import ApplyIPOUseCase from "@domains/features/TOCJourney/useCases/ApplyIPOUseCase";
import UserStatusUseCase from "@domains/features/TOCJourney/useCases/UserStatusUsecase";
import IpoOtpLeadUsecase from "@domains/features/TOCJourney/useCases/IpoOTPLeadsUseCase";
import IpoBankMasterUseCase from "@domains/features/TOCJourney/useCases/IpoBankMasterUseCase";
import IpoOtpValidateUseCase from "@domains/features/TOCJourney/useCases/IpoOtpValidateUseCase";
import IpoOtpRegisterUseCase from "@domains/features/TOCJourney/useCases/IpoOtpRegisterUseCase";
import IpoCancelUseCase from "@domains/features/TOCJourney/useCases/IpoCancelUseCase";
import MfPaymentStatusUseCases from "@domains/features/PaymentFlow/useCases/IMfPaymentStatusUseCase";
export default (repositories) => {
    return {
        tocJourney: {
            multiQuote: new MultiQuoteUseCase(repositories.tocJourney),
            placeNormalTrade: new PlaceNormalTradeUseCase(repositories.tocJourney),
            placeTradeComm: new PlaceTradeCommUseCase(repositories.tocJourney),
            orderDetailsUseCase: new OrderDetailsUseCase(repositories.tocJourney),
            checkMargin: new CheckMarginUseCase(repositories.tocJourney),
            brokerCharge: new BrokerChargeUseCase(repositories.tocJourney),
            brokerChargeComm: new BrokerChargeCommUseCase(repositories.tocJourney),
            rmsSubLimits: new RmsSubLimitsUseCase(repositories.tocJourney),
            limitsDetails: new LimitsUseCase(repositories.tocJourney),
            rmsHolding: new RmsHoldingUseCase(repositories.tocJourney),
            tpinHolding: new TpinUseCase(repositories.tocJourney),
            amoPlaceTrade: new AmoPlaceTradeUseCase(repositories.tocJourney),
            amoPlaceTradeComm: new AmoPlaceTradeCommUseCase(repositories.tocJourney),
            bracketTrade: new BracketTradeUseCase(repositories.tocJourney),
            esipTrade: new EsipTradeUseCase(repositories.tocJourney),
            cancelPlaceOrder: new CancelPlaceOrderUseCase(repositories.tocJourney),
            cancelEsipOrder: new CancelEsipOrderUseCase(repositories.tocJourney),
            modifyOrder: new ModifyOrderUseCase(repositories.tocJourney),
            authorize: new AuthorizeUseCase(repositories.tocJourney),
            amoStatus: new AMOStatusUseCase(repositories.tocJourney),
            mfPurchase: new MFPurchaseUseCase(repositories.tocJourney),
            nfoPurchase: new NfoPurchaseUseCase(repositories.tocJourney),
            mfSipFrequency: new MFSIPFrequencyUseCase(repositories.tocJourney),
            mfSipStartDate: new MFSIPStartDateUseCase(repositories.tocJourney),
            mfPurchaseOrder: new MFPurchaseOrderUseCase(repositories.tocJourney),
            MFParticularHolding: new MFParticularHoldingUseCase(repositories.tocJourney),
            MFAllHoldings: new MFAllHoldingsUseCase(repositories.tocJourney),
            placeOfsTrade: new OFSTradeUseCase(repositories.tocJourney),
            upiList: new UPIListUseCase(repositories.tocJourney),
            specificIPO: new SpecificIPOUseCase(repositories.tocJourney),
            applyIPO: new ApplyIPOUseCase(repositories.tocJourney),
            getUserStatus: new UserStatusUseCase(repositories.tocJourney),
            getIpoOtpLeads: new IpoOtpLeadUsecase(repositories.tocJourney),
            getIpoBankMaster: new IpoBankMasterUseCase(repositories.tocJourney),
            getIpoOtpValidate: new IpoOtpValidateUseCase(repositories.tocJourney),
            getIpoOtpRegister: new IpoOtpRegisterUseCase(repositories.tocJourney),
            getIpoCancel: new IpoCancelUseCase(repositories.tocJourney),
        },
        mandate: {
            mfMandate: new MFSipMandateUseCase(repositories.mandate),
            mfBankDetails: new MFBankDetailsUseCase(repositories.mandate),
            createMandate: new MFCreateMandateUseCase(repositories.mandate),
            uploadMandate: new MFMandateUploadUseCase(repositories.mandate),
            downloadMandate: new DownloadMandateUseCase(repositories.mandate),
            getEmandateUrl: new EmandateUrlUseCase(repositories.mandate),
            mandateSwitch: new MandateSwitchUseCase(repositories.mandate)
        },
        payment: {
            getPayBankDetails: new PayBankDetailsUseCase(repositories.payment),
            paymentGateway: new PaymentGatewayUseCase(repositories.payment),
            tradePayment: new TradePaymentUseCase(repositories.payment),
            getmfPaymentStatus: new MfPaymentStatusUseCases(repositories.payment)
        },
    };
};
